export enum Parameters {
  ID1 = 'X-Genesys-C2C_Channel',
  ID2 = 'X-Genesys-C2C_SessionID',
  ID3 = 'X-Genesys-C2C_BrwVer',
  ID4 = 'X-Genesys-C2C_MobAppVer',
  ID5 = 'X-Genesys-C2C_Platform_Soft_ver',
  ID6 = 'X-Genesys-C2C_Platform_Soft',
  ID7 = 'X-Genesys-C2C_Model',
  ID8 = 'X-Genesys-C2C_TricolorID',
}

export enum CallStatus {
  CONNECTING = 'connecting',
  CONFIRMED = 'confirmed',
}